import Completion from './Completion';

export default Completion;
